'use client'
import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useCallback,
  useMemo,
  useState,
} from 'react'
import { createPortal } from 'react-dom'

import { ToastNotification } from '@/components'
import { TToastNotification } from '@/components/shared/toast-notification'

export interface TToastNotificationContext extends TToastNotification {
  setState?: Dispatch<SetStateAction<TToastNotificationContext>>
}

export const ToastNotificationContext = createContext<TToastNotificationContext | null>(null)

export const defaultToastNotificationState: TToastNotificationContext = {
  show: false,
  type: 'success',
  title: '',
  content: null,
  traceId: '',
  disableClose: false,
  onClose: undefined,
}

const ToastNotificationProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<TToastNotificationContext>(defaultToastNotificationState)

  const onClose = useCallback(() => setState({ ...defaultToastNotificationState }), [])

  const value: TToastNotificationContext = useMemo(
    () => ({
      ...state,
      setState,
      onClose,
    }),
    [state, setState, onClose],
  )

  return (
    <ToastNotificationContext.Provider value={value}>
      {children}
      {state.show &&
        createPortal(<ToastNotification {...state} onClose={onClose} />, document.body)}
    </ToastNotificationContext.Provider>
  )
}

export default ToastNotificationProvider
